
import React, {useState} from 'react';
import Hashtag from "./Hashtag";


function App(props) {  

    return (
      <div className="component-view animate" data-animate="blendin 3s">
          <img className="image-view " src="./images/default.jpg" />          
          
          <div className="text-item text-header">
            Männerchor 1861 Opperode e.V. heißt Sie willkommen.
          </div>             
              
          
            
          <div className="text-item  text-block">
            Der Männerchor 1861 Opperode  e.V. ist bereits seit 1861 aktiv und hat seitdem einen positiven Einfluss auf den Harzkreis. 
            Dank der beeindruckenden Stimmfarben und Klänge werden Sie die Auftritte dieses Chores nicht so schnell vergessen. 
            Egal ob Tenor oder Bass, Männerchor 1861 Opperode e.V. kann jede Art von Musik in ein faszinierendes Erlebnis verwandeln. 
            Schauen Sie sich auf dieser Website um und erfahren Sie mehr.
          </div>
        </div>
      
     
            );
        }
    
    export default App;